import SectionHeading from './SectionHeading';
import { releaseItems } from '@/mocks/home';

export default function FirstRelease() {
  return (
    <section id="release" className="bg-background-100/70 py-14 md:py-20">
      <div className="mx-auto max-w-shell px-4 md:px-6">
        <SectionHeading
          eyebrow="FIRST RELEASE"
          title="抢先首发"
          desc="首发不拖延，整理好的重点内容一次看齐，每条都保留来源与更新时间。"
          action={{ label: '进入首发列表', href: '#release' }}
        />

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {releaseItems.map((item) => (
            <article
              key={item.id}
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200/80 bg-background-50 transition-colors hover:border-primary-300"
            >
              <div className="relative h-44 w-full overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  title={`${item.title} - 免费看料首发`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-md bg-primary-500 px-2.5 py-1 text-[11px] font-medium text-background-50">
                  {item.badge}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-5">
                <h3 className="font-heading text-base font-semibold leading-snug text-foreground-950 md:text-lg">
                  {item.title}
                </h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
                <div className="mt-4 flex items-center gap-3 border-t border-background-200/70 pt-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1.5">
                    <i className="ri-user-star-line text-sm"></i>
                    {item.source}
                  </span>
                  <span className="ml-auto flex items-center gap-1 text-secondary-600">
                    <i className="ri-time-line text-sm"></i>
                    {item.updatedAt}
                  </span>
                </div>
                <div className="mt-3 flex items-center gap-4 text-xs text-foreground-500">
                  <span className="flex items-center gap-1.5">
                    <i className="ri-chat-3-line text-sm"></i>
                    {item.comments}
                  </span>
                  <span className="flex items-center gap-1.5">
                    <i className="ri-eye-line text-sm"></i>
                    {item.views}
                  </span>
                  <a
                    href="#discuss"
                    className="ml-auto flex items-center gap-1 text-primary-600 transition-colors hover:text-primary-700 cursor-pointer"
                  >
                    看讨论
                    <i className="ri-arrow-right-s-line"></i>
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}